<template>
    <div class="modal-content">
        <div class="modal-header">
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
            >
                <span aria-hidden="true"><i class="fa fa-times"></i></span>
            </button>
        </div>
        <div class="modal-body">

            <div class="d-flex mb-3 border-bottom">
                <a class="link-option mr-3" :class="{active: openTab == 'create'}" href="#" @click.prevent="openTab = 'create'">
                    <i class="fas fa-pencil-alt"></i><span>SCHEDULE NEW REPORTS</span>
                </a>
                <a class="link-option" :class="{active: openTab == 'view'}" href="#" @click.prevent="openTab = 'view'">
                    <i class="fas fa-list"></i><span>VIEW SCHEDULED REPORTS</span>
                </a>
            </div>
            
            <GroupScheduleCreate :group_id="group_id" :teams="teams" :user="user" v-if="openTab == 'create'"/>
            <GroupScheduleView :group_id="group_id" :teams="teams" :user="user" v-if="openTab == 'view'"/>
        </div>
    </div>
</template>

<script>
import GroupScheduleCreate from './GroupScheduleCreate.vue';
import GroupScheduleView from './GroupScheduleView.vue';
export default {
    props: ["teams", "group_id", "user"],
    components: {
        GroupScheduleCreate, GroupScheduleView
    },

    data() {
        return {
            openTab: 'create'
        };
    }
};
</script>

<style>
.form-style {
    border-radius: 15px;
    cursor: pointer;
    background: #fff;
    border: solid 1px #e9eaec;
    padding: 10px 10px 10px 10px;
    position: relative;
    font-size: 11px;
}
</style>
